export const videoBlockInit = () => {
  const x = document.getElementById('video-button');

  if (x) {
    x.addEventListener('click', () => {
      document.getElementById('video-transcript').classList.toggle('video-block__transcript-content--expanded');
      document.getElementById('video-button-icon').classList.toggle('active');
    });
  }
};

export default videoBlockInit;
